import { LocalConfig } from "@/config";
export const LocationDefine = {
  EG: {
    name: "Egypt",
    code: "EG",
    currency: "EGP",
    currencyName: "Egyptian Pound",
    phoneStartsWith: "20",
    phoneNumberDigits: 10,
    utcOffsetMinutes: 120,
    timeZone: "Africa/Cairo",
    lang: "ar",
    flag: require("@/assets/images/header/flag_egypt.png").default,
    domain: "laka77.com",
    url: "https://laka77.com",
  },
  ID: {
    name: "Indonesia",
    code: "ID",
    currency: "IDR",
    currencyName: "Indonesian Rupiah",
    phoneStartsWith: "62",
    phoneNumberDigits: 12,
    phoneNumberMinDigits: 9,
    phoneNumberMaxDigits: 12,
    utcOffsetMinutes: 420,
    timeZone: "Asia/Jakarta",
    lang: "en",
    flag: require("@/assets/images/header/flag_yinni.png").default,
    domain: "",
    url: "https://2win9.com",
  },
};

/**
 *
 * @param {string | null} locationKey
 * @returns {name, code, currency, currencyName, phoneStartsWith, phoneNumberDigits, phoneNumberMinDigits, phoneNumberMaxDigits, lang, flag, domain, url}
 */
export function LocationInfo(locationKey) {
  if (!locationKey) {
    locationKey = LocalConfig.locationKey;
  }
  let upperLocationKey = locationKey.toUpperCase();
  if (!LocationDefine[upperLocationKey]) {
    let keys = Object.keys(LocationDefine);
    upperLocationKey = keys[keys.length - 1];
  }
  return LocationDefine[upperLocationKey];
}

export function getPhoneNumberMinDigits(regionInfo) {
  return regionInfo.phoneNumberMinDigits || regionInfo.phoneNumberDigits || 9;
}

export function getPhoneNumberMaxDigits(regionInfo) {
  return regionInfo.phoneNumberMaxDigits || regionInfo.phoneNumberDigits || 9;
}

export function getPhoneNumberDigitsText(regionInfo) {
  const minDigits = getPhoneNumberMinDigits(regionInfo);
  const maxDigits = getPhoneNumberMaxDigits(regionInfo);
  return minDigits == maxDigits ? `${maxDigits}` : `${minDigits}-${maxDigits}`;
}

export function isValidLocalPhone(phone, regionInfo) {
  const minDigits = getPhoneNumberMinDigits(regionInfo);
  const maxDigits = getPhoneNumberMaxDigits(regionInfo);
  const regex = new RegExp(`^[1-9][0-9]{${minDigits - 1},${maxDigits - 1}}$`);
  return regex.test(phone);
}
